export { default as RegionalProgress } from "./RegionalProgress.component";
export type { RegionalProgressProps } from "./RegionalProgress.component";
